import type { ApplicationManifest, ApplicationProps } from '@/applications/types';
import { DEFAULT_CAPABILITIES } from '@/applications/types';
import { asApplicationId } from '@/types';
import { InspectorContent } from '@/components/chrome/Inspector';
import styles from './InspectorApp.module.css';

/**
 * The property inspector as a persistent window (the floating panel remains the
 * default). It reuses the shell's inspector content so both stay identical.
 */
export const InspectorApp = ({ api }: ApplicationProps) => (
  <div className={styles.root} data-scrollable>
    {api.selectedIds.length ? (
      <InspectorContent ids={api.selectedIds} />
    ) : (
      <p className={styles.empty}>Select an object to inspect it.</p>
    )}
  </div>
);

export const inspectorManifest: ApplicationManifest = {
  id: asApplicationId('app.inspector'),
  name: 'Inspector',
  version: '1.0.0',
  icon: 'ⓘ',
  category: 'system',
  description: 'Properties of the current selection in a persistent window.',
  defaultSize: { width: 300, height: 480 },
  defaultPosition: 'cascade',
  capabilities: { ...DEFAULT_CAPABILITIES, multiInstance: false, persistsState: false, observesWorkspace: true },
  component: InspectorApp,
  normalizeState: () => ({}),
};
